/**
 * Получает объект WebApp или null, если он недоступен.
 * @returns {WebApp|null}
 */
const getWebApp = () => {
    const WebApp = window.Telegram?.WebApp;
    if (!WebApp) {
        console.warn("Telegram WebApp context is not available.");
    }
    return WebApp;
};

/**
 * Инициализирует базовые настройки Telegram Mini App.
 */
export const initTelegramDefaults = () => {
    const WebApp = getWebApp();
    if (!WebApp) return;
    try {
        console.log("TelegramService: Calling ready() and expand().");
        WebApp.ready();
        WebApp.expand();
        // Скрываем кнопку Назад по умолчанию при инициализации
        WebApp.BackButton.hide();
        console.log("TelegramService: BackButton hidden by default.");
    } catch (error) {
        console.error("TelegramService: Error in initTelegramDefaults:", error);
    }
};

/**
 * Инициализирует обработчик для кнопки "Назад" Telegram.
 * Вызывать один раз при инициализации приложения.
 * @param {Function} onClickCallback - Функция, которая будет вызвана при клике.
 */
export const initBackButton = (onClickCallback) => {
    const WebApp = getWebApp();
    if (!WebApp) return;
    try {
        console.log("TelegramService: Setting up BackButton listener.");
        // Сначала удаляем старый обработчик, если он был
        // WebApp.offEvent('backButtonClicked', onClickCallback);
        // Добавляем новый
        WebApp.onEvent('backButtonClicked', onClickCallback);
    } catch (error) {
        console.error("TelegramService: Error setting BackButton listener:", error);
    }
};

/**
 * Показывает кнопку "Назад" Telegram.
 */
export const showBackButton = () => {
    const WebApp = getWebApp();
    if (!WebApp?.BackButton) return;
    try {
        console.log("TelegramService: Showing BackButton.");
        WebApp.BackButton.show();
    } catch (error) {
        console.error("TelegramService: Error showing BackButton:", error);
    }
};

/**
 * Скрывает кнопку "Назад" Telegram.
 */
export const hideBackButton = () => {
    const WebApp = getWebApp();
    if (!WebApp?.BackButton) return;
    try {
        console.log("TelegramService: Hiding BackButton.");
        WebApp.BackButton.hide();
    } catch (error) {
        console.error("TelegramService: Error hiding BackButton:", error);
    }
};

/**
 * Инициализирует кнопку Настроек Telegram.
 * @param {Function} onClickCallback - Функция для клика.
 */
export const initSettingsButton = (onClickCallback) => {
    const WebApp = getWebApp();
    if (!WebApp?.SettingsButton) {
        console.log("TelegramService: SettingsButton not available.");
        return;
    };
    try {
        console.log("TelegramService: Setting up SettingsButton.");
        WebApp.SettingsButton.offClick(onClickCallback); // Очистка
        WebApp.SettingsButton.onClick(onClickCallback);
        WebApp.SettingsButton.show();
    } catch (error) {
        console.error("TelegramService: Error setting SettingsButton:", error);
    }
};

/**
 * Устанавливает цвет хедера Telegram.
 * @param {string} color - Цвет в формате HEX (#RRGGBB).
 */
export const setHeaderColor = (color) => {
    const WebApp = getWebApp();
    if (!WebApp?.setHeaderColor) {
        console.log("TelegramService: setHeaderColor not available.");
        return;
    }
    try {
        console.log(`TelegramService: Setting header color to ${color}`);
        WebApp.setHeaderColor(color);
    } catch (error) {
        console.error("TelegramService: Error setting header color:", error);
    }
};
/**
 * Отключает горизонтальный свайп.
 */
export const disableVerticalSwipes = () => {
    const WebApp = getWebApp();
    if (!WebApp?.disableVerticalSwipes) {
        console.log("TelegramService: disableVerticalSwipes not available.");
        return;
    }
    try {
        console.log("TelegramService: Disabling vertical swipes.");
        WebApp.disableVerticalSwipes();
    } catch (error) {
        console.error("TelegramService: Error disabling vertical swipes:", error);
    }
};

/**
 * Открывает ссылку (внутри Telegram или вовне, если не TG ссылка).
 * @param {string} url - URL для открытия.
 */
export const openLink = (url) => {
    const WebApp = getWebApp();
    if (!WebApp?.openLink) {
        console.error("TelegramService: openLink not available. Opening in new tab as fallback.");
        window.open(url, '_blank');
        return;
    };
    try {
        console.log(`TelegramService: Opening link: ${url}`);
        WebApp.openLink(url);
    } catch (error) {
        console.error("TelegramService: Error opening link:", error);
        window.open(url, '_blank'); // Fallback
    }
};

export const openTelegramLink = (url) => {
    const WebApp = getWebApp();
    if (!WebApp?.openTelegramLink) {
        console.error("TelegramService: openTelegramLink not available. Opening in new tab as fallback.");
        window.open(url, '_blank');
        return;
    };
    try {
        console.log(`TelegramService: Opening Telegram link: ${url}`);
        WebApp.openTelegramLink(url);
    } catch (error) {
        console.error("TelegramService: Error opening Telegram link:", error);
        window.open(url, '_blank'); // Fallback
    }
};

export const getColorScheme = () => {
    const WebApp = getWebApp();
    // Возвращает 'light', 'dark' или undefined
    return WebApp?.colorScheme;
};

/**
 * Вызывает тактильный отклик.
 * @param {('impact'|'notification'|'selection')} type - Тип отклика.
 * @param {('light'|'medium'|'heavy'|'success'|'warning'|'error')} style - Стиль отклика.
 */
export const hapticFeedback = (type, style) => {
    const WebApp = getWebApp();
    if (!WebApp?.HapticFeedback) return;

    try {
        if (type === 'impact') {
            WebApp.HapticFeedback.impactOccurred(style); // 'light', 'medium', 'heavy'
        } else if (type === 'notification') {
            WebApp.HapticFeedback.notificationOccurred(style); // 'success', 'warning', 'error'
        } else {
            WebApp.HapticFeedback.selectionChanged();
        }
    } catch (error) {
        console.error("TelegramService: Error in hapticFeedback:", error);
    }
};


// --- НОВЫЙ МЕТОД 2: Получение параметра запуска ---
/**
 * Безопасно получает start_param из данных инициализации.
 * @returns {string|null}
 */
export const getStartParam = () => {
    const WebApp = getWebApp();
    return WebApp?.initDataUnsafe?.start_param || null;
};


// --- НОВЫЙ МЕТОД 3: Очистка параметра запуска ---
/**
 * Очищает start_param, чтобы предотвратить повторный редирект при перезагрузке.
 */
export const clearStartParam = () => {
    const WebApp = getWebApp();
    // Используем безопасную проверку перед присваиванием
    if (WebApp && WebApp.initDataUnsafe) {
        WebApp.initDataUnsafe.start_param = '';
    }
};

/**
 * Проверяет, запущено ли приложение в среде Telegram Mini App.
 * @returns {boolean}
 */
export const isTelegramWebApp = () => {
    return !!window.Telegram?.WebApp?.initData;
};

// Добавьте другие функции по мере необходимости (openInvoiceLink, HapticFeedback и т.д.)
